'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002432 from "./presto.-Two-Factor-Auth-View$$anon$32.js";
import * as $j_presto$002etypes$0024 from "./presto.types$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$0024 from "./presto.types$-Two-Factor-Auth$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024 from "./presto.types$-Two-Factor-Auth-Name$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$31() {
  this.bCU = null;
  this.bCM = null;
  this.bCN = false;
  this.bCV = null;
  this.bCW = false;
  this.bCZ = null;
  this.bCS = null;
  this.bCT = false;
  this.bCO = null;
  this.bCP = false;
  this.bCQ = null;
  this.bCR = false;
  this.bCX = false;
  this.bCY = false;
  this.bCU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bCZ = "TwoFactorAuth";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$31 as $c_Lpresto_TwoFactorAuthView$$anon$31 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$31.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$31;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$31() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$31 as $h_Lpresto_TwoFactorAuthView$$anon$31 };
$h_Lpresto_TwoFactorAuthView$$anon$31.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bCU;
});
$p.M = (function() {
  if ((!this.bCN)) {
    this.bCM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bCN = true;
  }
  return this.bCM;
});
$p.O = (function() {
  if ((!this.bCW)) {
    this.bCV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bCW = true;
  }
  return this.bCV;
});
$p.D = (function() {
  return this.bCZ;
});
$p.t = (function() {
  if ((!this.bCT)) {
    this.bCS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("payload", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.bCT = true;
  }
  return this.bCS;
});
$p.N = (function() {
  if ((!this.bCP)) {
    this.bCO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().zs(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024.$m_Lpresto_types$TwoFactorAuthName$().zt(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024.$m_Lpresto_types$TwoFactorAuthType$().zv(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthPayload$().zu(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.bCP = true;
  }
  return this.bCO;
});
$p.Q = (function() {
  if ((!this.bCR)) {
    this.bCQ = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002432.$c_Lpresto_TwoFactorAuthView$$anon$32();
    this.bCR = true;
  }
  return this.bCQ;
});
$p.v = (function() {
  if ((!this.bCY)) {
    this.bCX = false;
    this.bCY = true;
  }
  return this.bCX;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee234) => ((p) => \u03b4scrutinee234.zk(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$0024.$m_Lpresto_types$TwoFactorAuth$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$31 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$31, "presto.TwoFactorAuthView$$anon$31", ({
  SB: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$31 as $d_Lpresto_TwoFactorAuthView$$anon$31 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$31.js.map
